import heroContent from '@content/hero.yaml'
import type { HeroContent } from '@/types/content'

const content = heroContent as unknown as HeroContent

export function Hero() {
  return (
    <section className="hero">
      <div className="hero-left">
        <div className="hero-pill"><span className="pill-dot"></span>{content.pill}</div>
        <h1 className="hero-h1" dangerouslySetInnerHTML={{ __html: content.headline }} />
        <p className="hero-sub">{content.subtext}</p>
        <div className="hero-actions">
          {content.actions.map(action => (
            <a key={action.href} href={action.href} className={action.style === 'primary' ? 'btn-p' : 'btn-o'}>{action.label}</a>
          ))}
        </div>
      </div>
      <div className="hero-right">
        {content.capabilities.map(cap => (
          <div key={cap.title} className="hvc">
            <div className={`hvc-icon ${cap.iconClass}`}>{cap.icon}</div>
            <div className="hvc-title">{cap.title}</div>
            <div className="hvc-body">{cap.body}</div>
          </div>
        ))}
      </div>
      <div className="hero-stats">
        {content.stats.map(stat => (
          <div key={stat.value} className="hstat">
            <div className="hstat-n">{stat.value}</div>
            <div className="hstat-l" dangerouslySetInnerHTML={{ __html: stat.label.replace(/\n/g, '<br/>') }} />
          </div>
        ))}
      </div>
      <div className="trust-badges">
        {content.trustBadges.map(badge => (
          <span key={badge.label} className="trust-badge">{badge.icon} {badge.label}</span>
        ))}
      </div>
    </section>
  )
}
